// extracted by mini-css-extract-plugin
export default {"cls1":"PostComments-cls1_MX9","cls2":"PostComments-cls2_MIV PostComments-cls1_MX9"};